export enum Variant {
    MSL = 'MSL',
    publisher = 'publisher',
    versioning = 'versioning',
    bookmark = 'bookmark',
}

// TODO: add video file types here as we add supports to them
export enum VIDEO_TYPES_ENUM {
    MP4 = 'MP4'
}

export enum ComplianceRuleStatus {
    PASSED = 'PASSED',
    FAILED = 'FAILED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum LangflowComplianceResult {
    COMPLIANT = 'COMPLIANT',
    PASSED = 'PASSED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
    NON_COMPLIANT = 'NON_COMPLIANT',
    FAILED = 'FAILED',
}
